exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".expedited-registration .isPersonSelector{display:flex;flex-direction:row;align-items:stretch;justify-content:space-between}.expedited-registration .isPersonSelector>div{flex:0 0 49%}.expedited-registration .registration-success{text-align:center;padding:36px}.expedited-registration .registration-success .header{padding-top:4px;padding-bottom:8px}", ""]);

// exports
